import { ArrowRight, CloneIcon, SaveIcon } from "../../icons";
import { Button } from "../../elements/Button";
import { ChoiceList } from "../../elements/ChoiceList";
import { Modal } from "../../elements/Modal";
import { UnsavedViewChangesModalProps } from "./UnsavedViewChangesModal.types";

/** Asks what to do with changes to a saved view before the page is left. */
export function UnsavedViewChangesModal({
  isSubmitting,
  onCancel,
  onContinueWithoutSaving,
  onSaveAndContinue,
  onSaveAsNewView,
}: UnsavedViewChangesModalProps) {
  return (
    <Modal title="Unsaved changes" onClose={onCancel}>
      <div className="modal-body">
        <p>
          You have unsaved filter changes in this saved view. Do you want to save them before
          leaving this page?
        </p>
        <ChoiceList
          disabled={isSubmitting}
          choices={[
            {
              title: "Save and continue",
              description: "Update this view, then leave the page",
              icon: SaveIcon,
              iconClassName: "text-primary",
              onClick: onSaveAndContinue,
              showSpinner: isSubmitting,
            },
            {
              title: "Save as new view",
              description: "Keep this view as it was and save a copy",
              icon: CloneIcon,
              iconClassName: "text-primary",
              onClick: onSaveAsNewView,
            },
            {
              title: "Continue without saving",
              description: "Discard your changes and leave the page",
              icon: ArrowRight,
              iconClassName: "text-danger",
              onClick: onContinueWithoutSaving,
            },
          ]}
        />
      </div>
      <div className="modal-footer justify-content-start">
        <Button text="Cancel" onClick={onCancel} />
      </div>
    </Modal>
  );
}
